import { CompanySearchAutocompleteItem } from 'src/app/shared/company-search-service/company-search.service';
import { CompanyStatuses, CourtProcedureType } from 'src/types';
import { DebtorCourtProcedureDialogData } from './debtor-court-procedure-dialog.component';

export function isTerminatedSoleEntrepreneur(
  company: CompanySearchAutocompleteItem | null | undefined,
): boolean {
  if (company?.status !== CompanyStatuses.SUSPENDED) {
    return false;
  }

  if (company.party_type?.type === 'ind') {
    return true;
  }

  return false;
}

export function getCompanyBlockDialogData(
  status: string | undefined | null,
  courtProcedureType?: CourtProcedureType | null,
): DebtorCourtProcedureDialogData | null {
  if (!status || status === CompanyStatuses.OPERATING) {
    return null;
  }

  if (status === CompanyStatuses.COURT_PROCEDURE) {
    return {
      variant: 'court_procedure',
      court_procedure_type: courtProcedureType ?? 'liquidation',
    };
  }

  return {
    variant: 'inactive',
    company_status: status === CompanyStatuses.SUSPENDED ? 'suspended' : 'unknown',
  };
}
